import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=0fd11a85&scoped=true&"
var script = {}
import style0 from "./advantage.vue?vue&type=style&index=0&id=0fd11a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd11a85",
  null
  
)

export default component.exports